<div class="relative block group">
    <div class="w-full hidden rounded-xl shadow-sm bg-white p-5 border-[1px] border-l-4 border-solid extra-small:block"
        [ngStyle]="{ 'border-color': cardColor }" *ngIf="!loading">
        <div class="flex items-start justify-between w-full">
            <div class="flex flex-col w-full">
                <div class="flex items-center mb-2">
                    <span
                        class="flex justify-center items-center material-symbols-outlined rounded-lg !text-[20px] m-0 !mr-[2px]"
                        [ngStyle]="{ 'color': cardColor }">{{iconName}}</span>
                    <p class="m-0 !text-lg ml-1" [ngStyle]="{ 'color': cardColor }">{{cardTitle}}</p>
                </div>
                <div class="w-full flex items-center justify-between">
                    <h4 class="m-0 font-medium" [ngStyle]="{ 'color': cardColor }">{{statusCount}}<span
                            *ngIf="isShowQuota" class="text-[22px]">/{{isShowQuota}}</span></h4>
                    <button (click)="routeToFilterEmployee()" *ngIf="routingPath"
                        class="bg-white shadow-[0px_0px_3px_0px_#80808052] rounded-3xl outline-none border-none w-auto px-4 !h-8 text-center !text-sm font-medium cursor-pointer float-end"
                        [ngStyle]="{ 'color': cardColor }">{{buttonTitle}}</button>
                </div>
            </div>
        </div>
    </div>
    <div class="w-auto block rounded-xl shadow-sm bg-white p-5 border-[1px] border-l-4 border-solid extra-small:hidden"
        [ngStyle]="{ 'border-color': cardColor }" *ngIf="!loading">
        <div class="flex items-start justify-between ">
            <div class="flex flex-col ">
                <div class="flex items-center mb-2">
                    <p class="m-0 !text-lg ml-1" [ngStyle]="{ 'color': cardColor }">{{cardTitle}}</p>
                </div>
                <div class="flex flex-col items-start justify-between">
                    <h4 class="m-0 font-medium" [ngStyle]="{ 'color': cardColor }">{{statusCount}}<span
                            *ngIf="isShowQuota" class="text-[22px]">/{{isShowQuota}}</span></h4>
                    <button (click)="routeToFilterEmployee()" *ngIf="routingPath"
                        class="bg-white shadow-[0px_0px_3px_0px_#80808052] rounded-3xl outline-none border-none w-auto px-4 !h-8 text-center !text-sm font-medium cursor-pointer float-end mt-3"
                        [ngStyle]="{ 'color': cardColor }">{{buttonTitle}}</button>
                </div>
            </div>
        </div>
    </div>
    <!-- Tooltip -->
    <div class="absolute w-full left-0 bg-white border border-gray-200 rounded-xl shadow-2xl p-4 z-50
               opacity-0 invisible group-hover:opacity-100 group-hover:visible
               transition-all duration-200 ease-in-out" *ngIf="isShowTooltip">
        <div class="absolute -top-2 right-4 w-4 h-4 bg-white border-l border-t border-gray-200 rotate-45"></div>
        <p class="text-base capitalize" [ngStyle]="{ 'color': cardColor }">
            {{cardTitle}} Users
        </p>
        <div class="mt-3 space-y-2 overflow-auto max-h-64">
            <div class="cursor-pointer px-3 py-2 rounded-md hover:bg-[#5459d1] hover:text-white transition"
                *ngFor="let employee of toolTipContent"
                (click)="routeEmployees(employee.id ? employee.id : employee.wpEmployee.id)">
                <p class="m-0 text-base capitalize">{{ employee.name ? employee.name : employee.wpEmployee.name }}</p>
            </div>
            <div class="cursor-pointer px-3 py-2 rounded-md" *ngIf="!toolTipContent || !toolTipContent.length">
                <p class="m-0 text-base capitalize">No {{cardTitle}} Users</p>
            </div>
        </div>
    </div>
</div>
<div class="w-full block rounded-xl shadow-sm" *ngIf="loading">
    <ngx-skeleton-loader style="display: block; width: 100%; height: 90px;"
        [theme]="{ 'border-radius': '12px', 'height': '90px'}"></ngx-skeleton-loader>
</div>